// extracted by mini-css-extract-plugin
export default {"carouselContainer":"Carousel_carouselContainer__K6wEr","carouselImage":"Carousel_carouselImage__y4uey","testimonialContainer":"Carousel_testimonialContainer__kIjgj"};